<!-- @author Amol, @date 29-08-2021, @description added assign batch plant company popup component-->
<div class="mainContent">

  <div style="height: 7vh;">
    <div>
      <label i18n="@@spmsUserReg" class="textColour" [ngStyle]="{'border-color':backgroundColorButton}">Assign User
        Role</label>
      <span class="example-spacer"></span>
    </div>
  </div>

  <div style="height: 57vh;overflow: auto;padding-left: 4%;padding-right: 4%;">
    
    <form novalidate [formGroup]="FormValid" style="width: 100%;">
      <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
          <mat-form-field appearance="outline">
            <mat-label>Select Company</mat-label>
            <mat-select formControlName="companyid" [(ngModel)]="assignUserRolePopupData.companyid" required (selectionChange)="DropdownDNS($event.value)">
              <mat-option *ngFor="let obj of companyData" [value]="obj.companyid">
                {{obj.compname}}</mat-option>
            </mat-select>
            <mat-error *ngFor="let validation of validation_messages.companyid">
              <span
                *ngIf="FormValid.get('companyid').hasError(validation.type) && (FormValid.get('companyid').dirty || FormValid.get('companyid').touched)">
                {{ validation.message }}
              </span>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
          <mat-form-field appearance="outline">
            <mat-label>Select Workspace</mat-label>
            <mat-select formControlName="tenantid" [(ngModel)]="assignUserRolePopupData.tenantid" required  (selectionChange)="retriveUser($event.value)">
              <mat-option *ngFor="let obj of DNSList" [value]="obj.id">
                {{obj.tenantname}}</mat-option>
            </mat-select>
            <mat-error *ngFor="let validation of validation_messages.dnsId">
              <span
                *ngIf="FormValid.get('tenantid').hasError(validation.type) && (FormValid.get('tenantid').dirty || FormValid.get('tenantid').touched)">
                {{ validation.message }}
              </span> 
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
          <mat-form-field appearance="outline">
            <mat-label>Select User Name</mat-label>
            <mat-select formControlName="userid" [(ngModel)]="assignUserRolePopupData.userid" required >
              <mat-option *ngFor="let obj of usersData" [value]="obj.userid">
                {{obj.username}}</mat-option>
            </mat-select>
            <mat-error *ngFor="let validation of validation_messages.userid">
              <span
                *ngIf="FormValid.get('userid').hasError(validation.type) && (FormValid.get('userid').dirty || FormValid.get('userid').touched)">
                {{ validation.message }}
              </span>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
          <mat-form-field appearance="outline">
            <mat-label>Select User Access Role</mat-label>
            <mat-select formControlName="userrolesmstrid" [(ngModel)]="assignUserRolePopupData.roleid" required>
              <mat-option *ngFor="let obj of userRoleNameData" [value]="obj.userrolesmstrid">
                {{obj.rolename}}</mat-option>
            </mat-select>
            <mat-error *ngFor="let validation of validation_messages.assignuserroleid">
              <span
                *ngIf="FormValid.get('userrolesmstrid').hasError(validation.type) && (FormValid.get('userrolesmstrid').dirty || FormValid.get('userrolesmstrid').touched)">
                {{ validation.message }}
              </span>
            </mat-error>
          </mat-form-field>
        </div>
      </div>


    </form>
  </div>
  <div style="height:5vh">
    <div class="row" style="position:sticky;left:0;bottom:0;width:100%;">

      <div class="col-lg text-center">

        <div style="text-align: end;display:flex; justify-content:flex-end; align-items:center;">
          

          <form [formGroup]="formValidCheckbox">

                <span *ngIf="buttonName == 'Save'">
                  <mat-checkbox
                    formControlName="isCheckboxSelected"
                    [(ngModel)]="isCheckboxSelected">
                  </mat-checkbox>

                  <span>Create Another</span>
                </span>

          </form>

             <!-- <button i18n="@@TargetClear" type="button" (click)="updateData()"
            class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            [style.background-color]="backgroundColorButton"
            style="padding: .3rem 1.6rem;font-size: .85rem;width:95px;color: white;">{{this.buttonName}}</button> -->

          <app-common-button
          label={{this.buttonName}}
          title={{this.buttonName}}
          [buttonId]="1111"
          width="110px"
          [critical]="false"
          (clicked)="updateData()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>

           <!-- <button i18n="@@TargetCancel" type="button" (click)="close()"
            class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            [style.background-color]="backgroundColorButton"
            style="padding: .3rem 1.6rem;font-size: .85rem;width:95px;color: white;">Cancel</button> -->
         
            <app-common-button
          label="Cancel"
          title="Cancel "
          [buttonId]="1111"
          variant="cancel"
          width="110px"
          [critical]="false"
          (clicked)="close()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
        </div>
      </div>
    </div>
  </div>
</div>